import * as React from 'react';
import { SVGProps } from 'react';

const IconEditSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.786 5.214 10 4 8 2 6.786 3.214l2 2zm-.572.572-2-2L2 8v2h2l4.214-4.214z" />
  </svg>
);
export default IconEditSizeXs;
